import React, { useEffect } from "react";
import BoxLoader from "../../commons/BoxLoader/BoxLoader";
import {
  BlueFlagIcon,
  CalanderGrayIcon,
  GreenFlagIcon,
  GreyFlagIcon,
  JobCloseIcon,
  LikeIcon,
  ManagerJobClosureIcon,
  RedFlagIcon,
} from "../../../assets/images";
import CustomizedAvatar from "../../commons/CircularAvatar/CustomizedAvatar";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
type AppProps = {
  thinksToDoFetching: boolean;
  history: any;
  jobClosureListData: any;
  handleApproveAndSendModal: (data: any) => void;
  type?: string;
  jobId?: string;
};
const ManagerJobClosureRequests = ({
  thinksToDoFetching,
  history,
  jobClosureListData,
  handleApproveAndSendModal,
  type,
  jobId,
}: AppProps) => {
  const [isPendingApprovalListPresent, setIsPendingApprovalListPresent] =
    useMenuCheck("open jobs");
  useEffect(() => {
    setIsPendingApprovalListPresent(
      "All Open Jobs Pending Approval List",
      "menu"
    );
  }, []);
  return (
    <div
      className="boxs scheduled-upcoming-interviews"
      style={{ overflow: "auto" }}
    >
      {thinksToDoFetching ? (
        <BoxLoader style={{ height: "100%" }} />
      ) : (
        <>
          <div className="d-flex justify-content-between">
            <div
              className="p-4 d-flex align-items-center w-75"
              style={{ gap: "3%" }}
            >
              <div>
                <img
                  src={type === "RM" ? JobCloseIcon : ManagerJobClosureIcon}
                  alt="user icon"
                />
              </div>
              <div>
                <p className="m-0" style={{ color: "#7c8db0" }}>
                  JOB TRACKER{" "}
                </p>
                <p
                  className="m-0"
                  style={{ fontSize: "14px", fontWeight: 600 }}
                >
                  {type === "RM"
                    ? "Job Closure Requests"
                    : "Approve Job & Send for Closure"}
                </p>
              </div>
            </div>
            <div className="d-flex align-items-center p-4">
              {/* {isPendingApprovalListPresent ? */}
              <span
                className="mr-3"
                style={{
                  textDecoration: "underline",
                  color: "#dd4433",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (type === "RM") {
                    history.push({
                      pathname: `/jobs/jobs-list`,
                      state: {
                        id: jobId,
                        showJobClosureRequest:true ,

                      },
                    });
                  } else {
                    history.push({
                      pathname: `/all-open-jobs`,
                      state: { activeTab: "jobsPendingApproval" },
                    });
                  }
                }}
              >
                {isPendingApprovalListPresent && type !== "RM"
                  ? "View All"
                  : type === "RM"
                  ? "View All"
                  : ""}
              </span>
            </div>
            {/* )} */}
          </div>
          <hr className="m-0"></hr>
          {jobClosureListData?.length > 0 ? (
            jobClosureListData?.map((el: any) => {
              return (
                <div>
                  <div
                    className="d-flex align-items-start p-3"
                    style={{ gap: "3%" }}
                  >
                    <div>
                      <span>
                        {el?.job_priority === "normal" ? (
                          <img src={GreyFlagIcon} />
                        ) : el?.job_priority === "red" ? (
                          <img src={RedFlagIcon} />
                        ) : el?.job_priority === "green" ? (
                          <img src={GreenFlagIcon} />
                        ) : el?.job_priority === "blue" ? (
                          <img src={BlueFlagIcon} />
                        ) : (
                          <span style={{ marginRight: "28px" }}> </span>
                        )}
                      </span>
                    </div>
                    <div>
                      <div>
                        <p
                          className="mt-0 mb-1"
                          style={{
                            color: "#262a44",
                            fontSize: "16px",
                            fontWeight: 500,
                            marginBottom: "-2px",
                          }}
                        >
                          {`${el?.job_id}_${el?.job_type ? el?.job_type : ""}_${
                            el?.period_ended
                          }`}
                        </p>
                        <p
                          style={{
                            margin: "0px 5px 5px 0px",
                            fontSize: "14px",
                            color: "#6e7491",
                          }}
                        >
                          {el?.job_description?.length > 60 ? (
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 250 }}
                              overlay={
                                <Tooltip id="button-view">
                                  {el?.job_description}
                                </Tooltip>
                              }
                            >
                              <span>
                                {el?.job_description
                                  .toLowerCase()
                                  ?.substr(0, 60) +
                                  (el?.job_description &&
                                  el?.job_description?.length > 60
                                    ? "..."
                                    : "")}
                              </span>
                            </OverlayTrigger>
                          ) : el?.job_description ? (
                            el?.job_description
                          ) : (
                            "--/--"
                          )}
                          {/* {`${
                            el?.job_description
                              ? el?.job_description
                              : ""
                          } `} */}
                        </p>
                      </div>
                      <div
                        style={{
                          color: "#6e7491",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            color: "#262a44",
                            display: "flex",
                            alignItems: "center",
                            fontWeight: 500,
                            marginBottom: "5px",
                          }}
                        >
                          <img src={CalanderGrayIcon} alt="calender-icon" />{" "}
                          <div className="ml-2">
                            <span>{` ${
                              el?.target_end_date ? el?.target_end_date : "NA"
                            }`}</span>
                          </div>
                          <div
                            className="ml-4"
                            style={{ display: "flex", gap: "3%" }}
                          >
                            <span>
                              <CustomizedAvatar
                                name={`${el?.approval_sent_by?.first_name} ${
                                  el?.approval_sent_by?.last_name
                                    ? el?.approval_sent_by?.last_name
                                    : ""
                                }`}
                                image={
                                  el?.approval_sent_by?.profile_pic?.file_url
                                }
                                style={{ width: "24px", fontSize: "10px" }}
                              />
                            </span>
                            <span style={{ width: "240px" }}>{`${
                              el?.approval_sent_by?.first_name
                            } ${
                              el?.approval_sent_by?.last_name
                                ? el?.approval_sent_by?.last_name
                                : ""
                            }`}</span>
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mt-2"
                        onClick={() => {
                          if (type === "RM") {
                            history.push({
                              pathname: `/jobs/jobs-list/edit-jobs/${el?._id}`,

                            });
                          } else {
                            handleApproveAndSendModal(el);
                          }
                        }}
                      >
                        {type === "RM"
                          ? "Close Job"
                          : "Approve & Send for Closure"}
                      </button>
                    </div>
                  </div>
                  <hr></hr>
                </div>
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "70%",
                flexDirection: "column",
              }}
            >
              <img src={LikeIcon} alt="like-icon" />
              <div
                className="mt-3"
                style={{
                  fontSize: "19px",
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                No Jobs are there!
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ManagerJobClosureRequests;
